import { TemplateList } from "../@types";
import { client, getErrorMessage } from "./client";

const baseUrl = "/report";

export const getTemplates = async (name?: string) => {
  try {
    const response = await client.get(`${baseUrl}/templates`, {
      params: name ? { name } : {},
    });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTemplate = async (id: number) => {
  try {
    const response = await client.get(`${baseUrl}/templates/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const createTemplate = async (template: TemplateList) => {
  try {
    const response = await client.post(`${baseUrl}/templates/save`, template);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const editTemplate = async (id: number, templateName: string) => {
  try {
    const response = await client.patch(`${baseUrl}/templates/${id}`, {
      name: templateName,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const deleteTemplate = async (id: number) => {
  try {
    const response = await client.delete(`${baseUrl}/templates/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

// 리포트 원본 데이터(DB row) — 집계는 components/report/reportMetrics
export const getReportData = async (id: number, validHistoryId?: number) => {
  try {
    const response = await client.get(`${baseUrl}/${id}/data`, { params: { validHistoryId } });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getReportConfig = async (id: number) => {
  try {
    const response = await client.get(`${baseUrl}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const saveReportConfig = async ({
  id,
  name,
  date_range,
  color_theme,
  class_filter,
  contents,
  valid_history_id,
}: {
  id: number;
  name?: string;
  date_range?: {};
  color_theme?: string;
  class_filter?: string[];
  contents?: any;
  valid_history_id?: number;
}) => {
  try {
    const response = await client.put(`${baseUrl}/${id}`, {
      name: name,
      date_range: date_range,
      color_theme: color_theme,
      class_filter: class_filter,
      contents: contents,
      valid_history_id: valid_history_id,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};
